/* Hide supplier claims that require evidence before publication. */
(() => {
  const unsupported = /radiation[- ]free|child[- ]safe|100,?000|shockproof|six[- ]month|6[- ]month|safe prolonged|glide up to 100 feet|protects? (the )?eyes|eye[- ]friendly/i;
  function review(root = document) {
    root.querySelectorAll('.bk-verified-description > :is(p,div,li)').forEach(node => {
      if (unsupported.test(node.textContent || '')) node.remove();
    });
  }
  review();
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) review(node);
  }))).observe(document.documentElement, {childList: true, subtree: true});
})();
